<template>
    <div class="modal fade" role="dialog" id="customer-absent-modal">
        <div class="modal-dialog modal-lg">

            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{transEdit('mark-customer-absent')}}</h5>
                    <button type="button" class="close" data-dismiss="modal">
                        <span><b>x</b></span>
                    </button>
                    <input type="hidden" id="customer-absent-modal-id">
                </div>
                <div class="modal-body">
                    <h4>{{transEdit('date-and-time')}}: </h4>
                    <h5>
                        <b><span id="customer-absent-modal-date"></span>, </b>
                        <span id="customer-absent-modal-time"></span>
                    </h5>

                    <h4>{{transEdit('customer')}}: </h4>
                    <h5><span id="customer-absent-modal-customer-name"></span></h5>

                    <h5>{{transEdit('comment')}}: </h5>
                    <textarea rows="5" cols="80" id="customer-absent-modal-comment" style="min-width: 100%;"></textarea>

                    <br>
                    <br>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger"
                            v-on:click="registerAbsence()"><i class="fa fa-user-times"></i> {{transEdit('mark-customer-absent')}}</button>
                    <button class="btn btn-dark"
                            data-dismiss="modal"><i class="fa fa-ban"></i> {{transEdit('cancel')}}</button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "therapist-dash-modal-customer-absent",
        props: ['route_absent'],
        methods: {
            registerAbsence: function () {
                let self = this;
                let thisModal = $("#customer-absent-modal");

                let bookingIdInput = $("#customer-absent-modal-id");
                let bookingId = bookingIdInput.val();

                let bookingAbsenceCommentInput = $("#customer-absent-modal-comment");
                let bookingAbsenceComment = bookingAbsenceCommentInput.val();

                axios.post(this.$portalUrl(self.route_absent), {
                    bookingId: bookingId,
                    absenceComment: bookingAbsenceComment,
                })
                .then(function (response) {
                    self.$emit('refresh');
                })
                .catch(function (error) {
                });

                thisModal.modal('toggle');
            }
        }
    }
</script>

<style scoped>

</style>
